import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-264db07d")

_pushScopeId("data-v-264db07d")
const _hoisted_1 = { class: "hd-wrap" }
const _hoisted_2 = { class: "op-l" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_4 = { class: "tit" }
const _hoisted_5 = { class: "op-r" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: 'hd' + (_ctx.wrapper ? ' wrapper' : '')
    }, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          class: "btn",
          onClick: _ctx.handleGoBack
        }, {
          default: _withId(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("h2", null, [
          _createVNode("span", null, _toDisplayString(_ctx.title), 1)
        ])
      ]),
      _createVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "headRight")
      ])
    ], 2)
  ]))
})